/* eslint-disable react/prop-types */
/* eslint-disable react/function-component-definition */
import React from "react";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDBadge from "../../../components/MDBadge";
import { IconButton, Tooltip } from "@mui/material";
import EditNoteIcon from "@mui/icons-material/EditNote";

export default function buildCustomerTable(data, onEdit, canUpdate = true) {
  const CustomerName = ({ name, role }) => (
    <MDBox display="flex" alignItems="center" lineHeight={1}>
      <MDBox ml={2}>
        <MDTypography display="block" variant="button" fontWeight="medium">
          {name}
        </MDTypography>
        <MDTypography variant="caption">{role}</MDTypography>
      </MDBox>
    </MDBox>
  );

  const columns = [
    { Header: "name", accessor: "customerStoreName", width: "45%", align: "left" },
    { Header: "phone", accessor: "phone", align: "center" },
    { Header: "action", accessor: "action", align: "center" },
  ];

  const rows = data.map((item) => {
    return {
      customerStoreName: <CustomerName name={item.storeName} role={item.role} />,
      phone: (
        <MDTypography display="block" variant="button" fontWeight="medium">
          {item.phone}
        </MDTypography>
      ),
      action: canUpdate ? (
        <Tooltip title="Edit">
          <IconButton
            color="info"
            size="small"
            onClick={(e) => {
              e.preventDefault();
              onEdit(item.id);
            }}
          >
            <EditNoteIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      ) : (
        <MDTypography variant="caption" color="text">
          —
        </MDTypography>
      ),
    };
  });

  return { columns, rows };
}
